export default function closeMegaMenu() {
    if (undefined !== document) {
        var element = document.getElementById('all-products') as HTMLInputElement;
        if (element && true === element.checked) {
            element.click();
        }
    }
}
